import { useLayoutEffect } from 'react';

export function useSetDataAttrs(ref, dataset) {
  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }
    (dataset ?? []).forEach(([name, value]) => {
      let stringifyValue = value.toString();
      if (typeof value == 'object') {
        stringifyValue = JSON.stringify(value);
      }
      ref.current.dataset[name] = stringifyValue;
    });
  }, [dataset, ref]);
}
